import FormArchives from '../../DAL/FormArchives'
import { getDocs, collection } from 'firebase/firestore'
import {store} from '../utilities'
import {category, activate} from '../action_creators'

export default function readSections(archiveId, formId) {
  return function () {
    if (!formId) return
    async function fetch() {
      const formArchives = new FormArchives()
      const snap = await getDocs(collection(formArchives.docRef(archiveId), 'sections'))
      const sections = {}
      snap.docs.forEach((d) => {
        sections[d.id] = {id: d.id, ...d.data()}
      })
      console.log('sections', sections)
      store.dispatch(category('sections')(sections))
      const state = store.getState()
      if (!state.active.section && state.form.order && state.form.order.length) {
        store.dispatch(activate('section', state.form.order[0]))
      }
    }
    fetch()
  }
}
